<em-main>
  <h3 class="layout--third-width" i18n>Comparateur de soumission</h3>

  <div class="layout--full-width layout--column layout--gap-larger">
    <em-quote-comparator-client-section [form]="clientFormGroup"></em-quote-comparator-client-section>

    <em-recommendations-section
      [recommendationsForm]="recommendationsFormArray"
      (productSectionAdded)="addProduct($event)"
      (recommendationSectionDeleted)="deleteRecommandation($event)"
      (productSectionDeleted)="deleteProduct($event)"
      (recommendationSectionAdded)="addRecommendation()"></em-recommendations-section>

    <p-button
      class="margin--top-medium justify-content-center flex"
      [disabled]="recommendationsFormArray.invalid || clientFormGroup.invalid"
      (onClick)="dialog = true"
      i18n-label
      label="Générer le visuel"></p-button>

    @if (dev) {
      <p-button label="Simulate" class="btn--simulate" (onClick)="simulate()"></p-button>
    }
  </div>
</em-main>

<p-dialog
  [dismissableMask]="true"
  [header]="
    clientFormGroup.controls.language.value === SupportedLanguage.FR
      ? 'Soumissions personnalisées pour ' + clientFormGroup.controls.firstName.value
      : 'Personalized quotes for ' + clientFormGroup.controls.firstName.value
  "
  [draggable]="false"
  [(visible)]="dialog"
  [style]="{width: '75vw', 'box-shadow': '0 2px 4px 1000px rgba(0, 0, 0, 0.15)'}">
  <div class="flex-column flex gap-6 pt-6">
    @for (recommendationForm of recommendationsFormArray.controls; track recommendationForm; let i = $index) {
      <div class="layout__inner-card flex-column relative flex p-6">
        <p class="solution">Solution #{{ i + 1 }}</p>
        @if (recommendationForm.controls.isRecommended.value) {
          <p class="recommended-quote">
            @if (clientFormGroup.controls.language.value === SupportedLanguage.FR) {
              <span>⭐️ Recommandé</span>
            }
            @if (clientFormGroup.controls.language.value === SupportedLanguage.EN) {
              <span>⭐️ Recommended</span>
            }
          </p>
        }
        <form
          class="align-items-start quote-comparator__recommandation-form"
          [formGroup]="recommendationForm">
          <div>
            @switch (recommendationForm.controls.company.value) {
              @case (Company.ASSOMPTION_VIE) {
                <img src="assets/insurance-logos/ASSOMPTION_VIE.svg" />
              }
              @case (Company.BENEVA) {
                <img src="assets/insurance-logos/BENEVA.svg" />
              }
              @case (Company.DESJARDINS) {
                <img src="assets/insurance-logos/DESJARDINS.svg" />
              }
              @case (Company.EMMA) {
                <img src="assets/insurance-logos/EMMA.svg" />
              }
              @case (Company.EMPIRE) {
                <img src="assets/insurance-logos/EMPIRE.svg" />
              }
              @case (Company.HUMANIA) {
                <img src="assets/insurance-logos/HUMANIA.svg" />
              }
              @case (Company.IA) {
                <img src="assets/insurance-logos/IA.svg" />
              }
              @case (Company.MANUVIE) {
                <img src="assets/insurance-logos/MANUVIE.svg" />
              }
              @case (Company.SUNLIFE) {
                <img src="assets/insurance-logos/SUNLIFE.svg" />
              }
              @case (Company.UV) {
                <img src="assets/insurance-logos/UV.svg" />
              }
            }
          </div>
          <div class="flex-column flex gap-3">
            @for (
              recProductsForm of recommendationForm.controls.products.controls;
              track recProductsForm;
              let j = $index
            ) {
              <div class="flex gap-3">
                <input
                  [readOnly]="true"
                  [value]="recProductsForm.controls.type.value"
                  id="type"
                  type="text"
                  pInputText />
                <input
                  [readOnly]="true"
                  [value]="
                    recProductsForm.controls.amount.value ?? 0 | currency: 'CAD' : 'symbol-narrow' : '1.0-0'
                  "
                  id="amount"
                  type="text"
                  pInputText />
                <input
                  [readOnly]="true"
                  [value]="
                    (recProductsForm.controls.price.value ?? 0
                      | currency: 'CAD' : 'symbol-narrow' : '1.2-2') +
                    (clientFormGroup.controls.language.value === SupportedLanguage.FR ? ' /mois' : ' /month')
                  "
                  id="price"
                  type="text"
                  pInputText />
              </div>
              @if (getReasonsAsArray(i, j).length > 0) {
                <ul>
                  @for (reason of getReasonsAsArray(i, j); track reason; let j = $index) {
                    <li>{{ reason }}</li>
                  }
                </ul>
              }
            }
          </div>
        </form>
        <p-divider></p-divider>
        <p>{{ recommendationForm.controls.reason.value }}</p>
      </div>
    }
  </div>
</p-dialog>
